export default class CloudflareDNS {


    constructor(domain)
    {
        this.domain=domain;
    }

    resolve(type)
    {
        return new Promise(resolve => {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                }
                else if (this.readyState === 4 && this.status !== 200) {
                    resolve({Status: -1, requestStatus: this.status});
                }
            };
            xhttp.open("GET", "https://cloudflare-dns.com/dns-query?name="+this.domain+"&type="+type, true);
            xhttp.setRequestHeader("accept",'application/dns-json');
            xhttp.send();
        });
    }

    getIP()
    {
        this.resolve("A").then(res => {
           var a= res.Answer;
           return a==="undefined" ? null : a.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/scripts/server/cloudflareSRV.js